import { useTranslate } from 'react-polyglot';

import { StatisticsIcon } from '@genially/icons';

import { useHostGameContext } from '../../../../HostGame.context';
import { SidebarLink } from '../SidebarLink/SidebarLink';

export const AnalyticsResultsSidebarLink = () => {
  const t = useTranslate();
  const { settingsSidebar, analyticsSidebar } = useHostGameContext();

  const handleClick = () => {
    settingsSidebar.close();

    analyticsSidebar.open();
  };

  return (
    <SidebarLink
      Icon={StatisticsIcon}
      text={t('__new.play.shared.viewResults')}
      onClick={handleClick}
    />
  );
};
